// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// ✅ Load jQuery before any Bootstrap/MDB scripts
import $ from "jquery";
window.$ = $;
window.jQuery = $;

// If you use Bootstrap's JS components:
import "bootstrap";
// If you have extra jQuery plugins, import them here too.